import React, { useState } from 'react';
import {
  Box,
  Collapse,
  Typography,
  IconButton
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const FooterDropdown = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <Box
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          color: '#8F9BB7',
          '&:hover': {
            color: '#00F5FF',
          }
        }}
      >
        <Typography
          component="span"
          sx={{
            flex: 1,
            transition: 'all 0.3s ease-in-out',
          }}
        >
          {title}
        </Typography>
        <IconButton
          size="small"
          sx={{
            color: 'inherit',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
            transition: 'transform 0.3s ease-in-out',
          }}
        >
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </Box>
      <Collapse in={isOpen}>
        <Box
          sx={{
            mt: 1,
            p: 2,
            backgroundColor: 'rgba(0, 245, 255, 0.05)',
            borderRadius: 1,
            border: '1px solid rgba(0, 245, 255, 0.1)',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: '#8F9BB7',
              lineHeight: 1.6,
            }}
          >
            {content}
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

export default FooterDropdown;
